query isLastRegenerationFinished($companyId: ID!) {
  isLastRegenerationFinished(companyId: $companyId)
}
